export const makeFormData = (program, values) => {
    let leaderboardData = {};
    let {
        name,
        leaderboard_type_id,
        status_id,
        visible,
        enable,
        one_leaderboard,
        start_date,
        end_date,
    } = values;
    leaderboardData.name = name;
    leaderboardData.status_id = status_id;
    leaderboardData.visible = visible ? 1 : 0;
    leaderboardData.enable = enable ? 1 : 0;
    leaderboardData.one_leaderboard = one_leaderboard ? 1 : 0;
    //static
    leaderboardData.leaderboard_type_id = leaderboard_type_id?.value || null;
     //ADD DATES TO FORM DATA
    leaderboardData.start_date = start_date
        ? start_date instanceof Date
            ? start_date.toISOString().split("T")[0]
            : start_date
        : null;

    leaderboardData.end_date = end_date
        ? end_date instanceof Date
            ? end_date.toISOString().split("T")[0]
            : end_date
        : null;
    return leaderboardData
}
